<section [style.height.rem]="params.height"></section>
